/* 🤖 this file was generated by svg-to-ts */
export const matIconWbIncandescent: {
  name: 'wb-incandescent';
  data: string;
} = {
  name: 'wb-incandescent',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="m3.55 19.09 1.41 1.41 1.79-1.8-1.41-1.41zM11 20h2v3h-2zM1 11h3v2H1zm12-6.95v3.96l1 .58c1.24.72 2 2.04 2 3.46 0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.42.77-2.74 2-3.46l1-.58V4.05h2m2-2H9v4.81C7.21 7.9 6 9.83 6 12.05c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19V2.05zM20 11h3v2h-3zm-2.76 7.71 1.79 1.8 1.41-1.41-1.8-1.79z"/></svg>`
};
